import styled from 'styled-components';
import { palette } from 'styled-theme';
import { Label } from '../../../Components/uielements';

export const FeatureAddOnWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 50px;
`;
export const FeatureAddOnLeft = styled.div``;
export const FeatureAddOnRight = styled.div``;

export const ModalWrapper = styled.div`
  display: grid;
  gap: 10px;
  padding: 20px 20px 30px;
  max-width: 600px;
  padding: 20px 20px 30px;
  max-width: 900px;
  max-height: 600px;
`;
export const ModalButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 20px;
  padding-bottom: 20px;
  max-width: fit-content;
  justify-self: center;
`;

export const RadioGroup = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 30px;
`;

export const RadioButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  cursor: pointer;
`;

export const RadioButtonField = styled.input.attrs({ type: 'radio' })`
  margin-right: 8px;
  cursor: pointer;
  width: 20px;
  height: 20px;
`;

export const Columns = styled.div`
  display: grid;
  grid-template-columns: 2fr 1fr;
  justify-content: space-between;
  gap: 35px;
`;

export const FourColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  justify-content: space-between;
  column-gap: 20px;
  row-gap: 60px;
  padding-top: 20px;
`;
export const ThreeColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  justify-content: space-between;
  column-gap: 20px;
  row-gap: 60px;
  padding-top: 20px;
`;

export const TwoColumns = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-content: space-between;
  column-gap: 20px;
  row-gap: 60px;
  padding-top: 20px;
`;

export const GapColums = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 30px;
  padding-top: 24px;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  gap: 10px;
  margin-top: 40px;
  padding-bottom: 20px;
  max-width: fit-content;
`;

export const FeatureListContainer = styled.div``;

export const FeatureList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
`;

export const FeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 8px;
  color: #fff;
  font-size: 14px;
`;

export const ArrowIcon = styled.span`
  color: #e6b471;
  margin-right: 8px;
  margin-top: 2px;
  flex-shrink: 0;
  font-weight: bold;
`;

export const FeatureText = styled.span`
  flex: 1;
  line-height: 1.4;
`;

export const InfoIconWrapper = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  cursor: pointer;
`;

export const Tooltip = styled.div`
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-bottom: 8px;
  padding: 12px 16px;
  background-color: #0b2629;
  border: 1px solid rgba(255, 255, 255, 0.1);
  color: white;
  border-radius: 6px;
  font-size: 13px;
  line-height: 1.5;
  width: 280px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 1000;
  pointer-events: none;
  opacity: ${(props) => (props.show ? '1' : '0')};
  visibility: ${(props) => (props.show ? 'visible' : 'hidden')};
  transition:
    opacity 0.2s ease,
    visibility 0.2s ease;
`;

export const TooltipTitle = styled.div`
  font-weight: 600;
  margin-bottom: 6px;
  color: #e6b471;
`;

export const TooltipText = styled.div`
  color: rgba(255, 255, 255, 0.9);
`;

export const PermissionRowWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 18px;
  padding: 10px;
  border: 1px solid #eee;
  flex-wrap: wrap;
  border-radius: 6px;
`;

export const PermissionLabel = styled(Label)`
  min-width: 140px;
  margin: 0;
  font-weight: 600;
  text-transform: capitalize;
`;

export const PermissionActions = styled.div`
  display: flex;
  flex: 1;
  gap: 20px;
  flex-wrap: wrap;
`;

export const PermissionAction = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const RangeFieldWrapper = styled.div`
  width: 120px;
`;

export const SwitchWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const InfoText = styled(Label)`
  color: ${palette('text', 4)};
  margin: 0;
  font-weight: 500;
`;

export const PermissionNumberField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 120px;
`;

export const PermissionNumberLabel = styled(Label)`
  margin: 0;
  color: ${palette('text', 1)};
`;

export const PermissionNumberInput = styled.input`
  width: 100%;
  height: 40px;
  padding: 0 12px;
  border: 1px solid ${palette('border', 2)};
  border-radius: 6px;
  background: transparent;
  color: ${palette('text', 1)};
  font-size: 14px;
  outline: none;
  box-sizing: border-box;

  &:focus {
    border-color: ${palette('active', 0)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;
